import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { InterceptorService } from '@coreModule/services/interceptorService';

@Injectable()
export class SessionStorageCheckInterceptor implements HttpInterceptor {
  constructor(private interceptorService: InterceptorService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tenant = sessionStorage.getItem('tenant');
    if (!tenant) {
      this.interceptorService.redirect('400.html');
      return of();
    }
    return next.handle(req);
  }
}
